import { useEffect, useState } from "react";
import { supabase } from "../config/supabaseClient";
import { useAuth } from "../context/AuthContext";
import { ORASE, RASE_CAINE, RASE_PISICA, CULORI } from "../data/optiuniAnunt";
import {
  FaTrash, FaEdit, FaSave, FaTimes, FaPhone, FaEnvelope,
  FaMapMarkerAlt, FaPaw, FaVenus, FaMars, FaHeart,
  FaHandHoldingHeart, FaTrophy, FaStar
} from "react-icons/fa";
import { MdAppSettingsAlt } from "react-icons/md";
import "./ListaAnunturiMele.css";

const SUME_DONATIE = [
  { lei: 50 }, { lei: 100 }, { lei: 200 }, { lei: 500 }, { lei: 1000 },
];

export default function ListaAnunturiMele({ tip, doarPromovate = false }) {
  const { user } = useAuth();
  const [anunturi, setAnunturi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [donatieId, setDonatieId] = useState(null);
  const [succes, setSucces] = useState({ id: null, mesaj: "" });

  useEffect(() => {
    const fetchAnunturi = async () => {
      let query = supabase
        .from("anunturi")
        .select("*")
        .eq("user_id", user.id)
        .eq("tip", tip)
        .order("created_at", { ascending: false });

      if (doarPromovate) query = query.eq("promovat", true);

      const { data, error } = await query;
      if (!error) setAnunturi(data);
      setLoading(false);
    };
    fetchAnunturi();
  }, [user, tip, doarPromovate]);

  const handlePromoveaza = async (anuntId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/stripe/promoveaza`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ anunt_id: anuntId, user_id: user.id }),
        }
      );
      const { url } = await res.json();
      window.location.href = url;
    } catch (err) {
      alert("Eroare: " + err.message);
    }
  };

  const handleSterge = async (id) => {
    if (!window.confirm("Ești sigur că vrei să ștergi acest anunț?")) return;
    const { error } = await supabase.from("anunturi").delete().eq("id", id);
    if (!error) setAnunturi((prev) => prev.filter((a) => a.id !== id));
  };

  const handleEditStart = (a) => {
    setEditId(a.id);
    setEditForm({
      specie: a.specie, rasa: a.rasa, sex: a.sex,
      culoare: a.culoare, oras: a.oras,
      telefon: a.telefon, email: a.email, detalii: a.detalii,
    });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "specie" ? { rasa: "" } : {}),
    }));
  };

  const handleEditSave = async (id) => {
    const { error } = await supabase
      .from("anunturi").update(editForm).eq("id", id);
    if (!error) {
      setAnunturi((prev) =>
        prev.map((a) => (a.id === id ? { ...a, ...editForm } : a))
      );
      setEditId(null);
    }
  };

  const handleDonatie = async (suma) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/stripe/checkout`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ suma, userId: user.id }),
        }
      );
      const { url } = await res.json();
      window.location.href = url;
    } catch (err) {
      alert("Eroare la inițierea plății: " + err.message);
    }
  };

  const handleSucces = async (id) => {
    const { error } = await supabase
      .from("anunturi")
      .update({
        rezolvat: true,
        rezolvat_la: new Date().toISOString(),
        mesaj_succes: succes.mesaj,
        activ: false,
      })
      .eq("id", id);

    if (!error) {
      setAnunturi((prev) => prev.filter((a) => a.id !== id));
      setSucces({ id: null, mesaj: "" });
      alert("Felicitări! 🎉 Povestea voastră apare acum în Succese FindMyPet!");
    }
  };

  const rase = editForm.specie === "caine" ? RASE_CAINE : RASE_PISICA;

  if (loading) return <p>Se încarcă...</p>;
  if (anunturi.length === 0) return (
    <div className="lista-goala">
      <FaPaw size={40} color="#ddd" />
      <p>{doarPromovate ? "Nu ai niciun anunț promovat." : "Nu ai niciun anunț încă."}</p>
    </div>
  );

  return (
    <div className="lista-anunturi">
      {anunturi.map((a) => (
        <div key={a.id} className={`anunt-card-complet ${a.promovat ? "card-promovat" : ""}`}>

          {a.promovat && (
            <div className="promovat-ribbon">
              <FaStar size={12} /> Promovat
            </div>
          )}

          {/* Imagini */}
          <div className="anunt-imagini">
            {a.imagini?.length > 0 ? (
              a.imagini.map((src, i) => (
                <img key={i} src={src} alt={`animal ${i + 1}`} />
              ))
            ) : (
              <div className="no-image">
                <FaPaw size={32} color="#ccc" />
                <span>Fără poză</span>
              </div>
            )}
          </div>

          {/* Detalii / Edit */}
          <div className="anunt-detalii">
            <div className="anunt-header">
              <span className={`badge ${a.tip === "gasit" ? "badge-gasit" : "badge-pierdut"}`}>
                {a.tip === "gasit" ? "🟢 Găsit" : "🔴 Pierdut"}
              </span>
              <small>{new Date(a.created_at).toLocaleDateString("ro-RO")}</small>
            </div>

            {editId === a.id ? (
              <div className="edit-form">
                <div className="edit-grid">
                  <select name="specie" value={editForm.specie} onChange={handleEditChange}>
                    <option value="">Specie</option>
                    <option value="caine">Câine</option>
                    <option value="pisica">Pisică</option>
                  </select>
                  {editForm.specie && (
                    <select name="rasa" value={editForm.rasa} onChange={handleEditChange}>
                      <option value="">Rasă</option>
                      {rase.map((r) => <option key={r} value={r}>{r}</option>)}
                    </select>
                  )}
                  <select name="sex" value={editForm.sex} onChange={handleEditChange}>
                    <option value="">Sex</option>
                    <option value="mascul">♂ Mascul</option>
                    <option value="femela">♀ Femelă</option>
                    <option value="necunoscut">Necunoscut</option>
                  </select>
                  <select name="culoare" value={editForm.culoare} onChange={handleEditChange}>
                    <option value="">Culoare</option>
                    {CULORI.map((c) => <option key={c} value={c}>{c}</option>)}
                  </select>
                  <select name="oras" value={editForm.oras} onChange={handleEditChange}>
                    <option value="">Oraș</option>
                    {ORASE.map((o) => <option key={o} value={o}>{o}</option>)}
                  </select>
                  <input name="telefon" value={editForm.telefon || ""} onChange={handleEditChange} placeholder="Telefon" />
                  <input name="email" value={editForm.email || ""} onChange={handleEditChange} placeholder="Email" />
                </div>
                <textarea
                  name="detalii" value={editForm.detalii || ""}
                  onChange={handleEditChange} rows={3}
                  placeholder="Detalii suplimentare..."
                />
                <div className="edit-butoane">
                  <button className="btn-salveaza" onClick={() => handleEditSave(a.id)}>
                    <FaSave /> Salvează
                  </button>
                  <button className="btn-anuleaza" onClick={() => setEditId(null)}>
                    <FaTimes /> Anulează
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className="anunt-grid">
                  <div className="anunt-item">
                    <span className="label">Specie</span>
                    <span>{a.specie === "caine" ? "🐕 Câine" : "🐈 Pisică"}</span>
                  </div>
                  <div className="anunt-item">
                    <span className="label">Rasă</span>
                    <span>{a.rasa || "—"}</span>
                  </div>
                  <div className="anunt-item">
                    <span className="label">Sex</span>
                    <span>
                      {a.sex === "mascul"
                        ? <><FaMars color="#3b82f6" /> Mascul</>
                        : a.sex === "femela"
                        ? <><FaVenus color="#ec4899" /> Femelă</>
                        : "Necunoscut"}
                    </span>
                  </div>
                  <div className="anunt-item">
                    <span className="label">Culoare</span>
                    <span>{a.culoare || "—"}</span>
                  </div>
                  <div className="anunt-item">
                    <span className="label"><FaMapMarkerAlt /> Oraș</span>
                    <span>{a.oras || "—"}</span>
                  </div>
                  <div className="anunt-item">
                    <span className="label"><FaPhone /> Telefon</span>
                    <span>{a.telefon || "—"}</span>
                  </div>
                  <div className="anunt-item">
                    <span className="label"><FaEnvelope /> Email</span>
                    <span>{a.email || "—"}</span>
                  </div>
                </div>

                {a.detalii && (
                  <div className="anunt-descriere">
                    <span className="label">Detalii</span>
                    <p>{a.detalii}</p>
                  </div>
                )}

                <div className="anunt-butoane">
                  <button className="btn-edit" onClick={() => handleEditStart(a)}>
                    <FaEdit /> Editează
                  </button>
                  <button className="btn-sterge" onClick={() => handleSterge(a.id)}>
                    <FaTrash /> Șterge
                  </button>
                  <button className="btn-succes" onClick={() => setSucces({ id: a.id, mesaj: "" })}>
                    <FaTrophy /> Animal găsit!
                  </button>
                  <button
                    className={`btn-promoveaza ${a.promovat ? "deja-promovat" : ""}`}
                    onClick={() => !a.promovat && handlePromoveaza(a.id)}
                    disabled={a.promovat}
                  >
                    <FaStar />
                    {a.promovat ? "⭐ Promovat" : "Promovează — 25 Lei"}
                  </button>
                </div>

                {succes.id === a.id && (
                  <div className="succes-modal-overlay" onClick={() => setSucces({ id: null, mesaj: "" })}>
                    <div className="succes-modal" onClick={(e) => e.stopPropagation()}>
                      <div className="succes-modal-header">
                        <FaTrophy size={32} color="#f97316" />
                        <h3>Felicitări! 🎉</h3>
                        <p>Povestea ta va inspira alți oameni. Vrei să lași un mesaj?</p>
                      </div>
                      <textarea
                        value={succes.mesaj}
                        onChange={(e) => setSucces((prev) => ({ ...prev, mesaj: e.target.value }))}
                        placeholder="Ex: L-am găsit după 3 zile datorită FindMyPet! Mulțumesc tuturor..."
                        rows={4}
                        className="succes-textarea"
                      />
                      <div className="succes-modal-butoane">
                        <button className="btn-confirma-succes" onClick={() => handleSucces(a.id)}>
                          <FaTrophy /> Confirmă — animal găsit acasă!
                        </button>
                        <button className="btn-anuleaza" onClick={() => setSucces({ id: null, mesaj: "" })}>
                          <FaTimes /> Anulează
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            <div className="donatie-section">
              <button
                className="btn-donatie-toggle"
                onClick={() => setDonatieId(donatieId === a.id ? null : a.id)}
              >
                <FaHeart /> Donează — ai găsit animalul?
              </button>
              {donatieId === a.id && (
                <div className="donatie-box">
                  <div className="donatie-info">
                    <div className="donatie-split">
                      <div>
                        <MdAppSettingsAlt size={20} color="#f97316" />
                        <span><strong>50%</strong> dezvoltarea aplicației FindMyPet</span>
                      </div>
                      <div>
                        <FaHandHoldingHeart size={20} color="#ec4899" />
                        <span><strong>50%</strong> asociații pentru animale</span>
                      </div>
                    </div>
                  </div>
                  <div className="donatie-sume">
                    {SUME_DONATIE.map(({ lei }) => (
                      <button key={lei} className="btn-suma" onClick={() => handleDonatie(lei)}>
                        {lei} Lei
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      ))}
    </div>
  );
}